import { render, staticRenderFns } from "./GroupsForm.vue?vue&type=template&id=76e45258&scoped=true"
import script from "./GroupsForm.vue?vue&type=script&lang=js"
export * from "./GroupsForm.vue?vue&type=script&lang=js"
import style0 from "./GroupsForm.vue?vue&type=style&index=0&id=76e45258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e45258",
  null
  
)

export default component.exports